import React, { useEffect, useState } from "react";
import axiosInstance from "../../../api/api";
import { Button, Col, Form, Modal, Row, Table } from "@themesberg/react-bootstrap";
import DetailCompetitor from "./DetailCompetitor";
import CardLayout from "../Layout/CardLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import DOMPurify from "quill/formats/link";

const Mercado = (ciemId) => {
    const [formData, setFormData] = useState({
        id: null,
        segmento: '',
        propuesta: '',
        canales: '',
        ciemId: ciemId.ciemId,
        recursos: '',
        estrategia: ''
    });
    const [tableHeaders, setTableHeaders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);


    // Cargar datos al iniciar
    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            if (ciemId.ciemId) {
                fetchDetails()
            }
        }

        return () => {
            isMounted = false;
        };
    }, [ciemId.ciemId]);

    const fetchDetails = async () => {
        setLoading(true);
        try {
            //titulos y campos mercado Objetivo
            await axiosInstance.get('/detailoption/option/value/mercadoTable').then((response) => {
                setTableHeaders(response.data.data);
                console.log("tabla mercado" + tableHeaders)
            }).catch((e) => {
                alert("Error consultando la tabla " + e)
            });
        } catch (error) {
            alert("Mensaje del sistema " + error.message)
            console.error(error);
        } finally {
            setLoading(false);
        }

        await axiosInstance.get('demanda/mercadodesc/' + ciemId.ciemId).then((response) => {
            console.log("informacion consultada")
            console.log(response.data.data)
            if (response.data.data) {
                setFormData(response.data.data);
            }
            //console.log("informacion guardada" + formData)
        }).catch((e) => {
            //console.log(e)
            alert("Mensaje del sistema " + e.message)
        });

    };

    const handleChangemercado = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const [modalInfo, setModalInfo] = useState({ title: '', content: '' });

    const handleShowModalmercado = (title, content) => {
        setModalInfo({ title, content });
        setShowModal(true);
    };
    const handleCloseModalmercado = () => setShowModal(false);
    const handleSubmit = async () => {
        try {
            //calcular valores
            console.log("Guardando y calculando valores")
            console.log(formData)
            //await axios.put(`/api/detailcompetitors/${form.id}`, form);
            await axiosInstance.post('demanda/mercadodesc', formData).then((response) => {
                if (response) {
                    setFormData(response.data.data);
                }
                console.log("informacion consultada" + setFormData())
            }).catch((e) => {
                alert("Error consultando la tabla ")
            });
            // await fetchDetails();
        } catch (err) {
            console.log(err)
            alert('Error al guardar');
        }
    };



    const contributionForm = <Form>
        <Row>
            <Col md={6}>
                <Form.Group controlId="continente">
                    {tableHeaders.map((titulo) => (
                        <React.Fragment key={titulo.id}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <Form.Label className="mb-0">{titulo.description}</Form.Label>

                                {titulo.tooltip && (
                                    <Button
                                        variant="link"
                                        onClick={() => handleShowModalmercado("Información", titulo.tooltip)}
                                        style={{ padding: 0, fontSize: '1rem', lineHeight: 1 }}
                                        className="text-info"
                                        aria-label="Ver información"
                                    >
                                        <FontAwesomeIcon icon={faInfoCircle} />
                                    </Button>
                                )}

                                {titulo.modal && (
                                    <Button
                                        variant="link"
                                        onClick={() => handleShowModalmercado(titulo.value, titulo.modal)}
                                        style={{ padding: 0, fontSize: '0.9rem', lineHeight: 1 }}
                                        aria-label="Más información"
                                    >
                                        Más información
                                    </Button>
                                )}
                            </div>

                            {showModal && modalInfo.content && (
                                <Modal show onHide={handleCloseModalmercado}>
                                    <Modal.Header closeButton>
                                        <Modal.Title>{modalInfo.title}</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(modalInfo.content),
                                            }}
                                        />
                                    </Modal.Body>
                                    <Modal.Footer>
                                        <Button variant="secondary" onClick={handleCloseModalmercado}>
                                            Cerrar
                                        </Button>
                                    </Modal.Footer>
                                </Modal>
                            )}

                            <Form.Control
                                as="textarea"
                                rows={5}
                                name={titulo.value}
                                value={formData[titulo.value] || ""}
                                onChange={(e) => handleChangemercado(e)}
                                maxLength={1000}
                                style={{ width: "100%" }}
                            />
                        </React.Fragment>
                    ))}
                </Form.Group>
            </Col>
        </Row>
        <p></p>
        <Button variant="primary" onClick={handleSubmit}>
            Guardar
        </Button>
    </Form>


        ;

    return (
        <div className="container-fluid">
            <CardLayout value={"mercadoTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};

export default Mercado;